import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getDocumentsSimStudioData = createAsyncThunk(
  'documentsSimStudioData/get',
  API.documentsSimStudioData.get,
);

export const updateSimStudioDocument = createAsyncThunk(
  'documentsSimStudioData/update',
  async ({
    id,
    enabled,
    simstudioUrl,
    simstudioApiKey,
    workflowId,
  }: {
    id: string;
    enabled: string;
    simstudioUrl: string;
    simstudioApiKey?: string;
    workflowId: string;
  }) =>
    API.documentsSimStudioData.update({ 
      id, 
      enabled: enabled === 'true', 
      simstudioUrl, 
      simstudioApiKey,
      workflowId 
    }),
);

export const createSimStudioDocument = createAsyncThunk(
  'documentsSimStudioData/create',
  async ({
    id,
    displayName,
    simstudioUrl,
    simstudioApiKey,
    workflowId,
  }: {
    id: string;
    displayName: string;
    simstudioUrl: string;
    simstudioApiKey: string;
    workflowId: string;
  }) =>
    API.documentsSimStudioData.create({ id, displayName, simstudioUrl, simstudioApiKey, workflowId }),
);

export const deleteSimStudioDocument = createAsyncThunk(
  'documentsSimStudioData/delete',
  async (id: string) => {
    await API.documentsSimStudioData.remove(id);
    return id;
  },
);
